import { Linking } from "react-native";
import analytics from "@services/analytics";
/*
Call button tracking events

1-Call Agent
2-CTA Clicked
3-CMO_CX call button clicked
4-Cx Detail Call
5-Customer called
6-DB called
7-DB_CALL_BUTTON_CLICKED
8-Refer Call Reminder
9-Marking widget clicked
10-Delivery Card Call Btn
*/
const handleCallButtonPress = (
  phoneNumber,
  eventName,
  analyticsProps,
  callback,
) => {
  if (!phoneNumber) {
    console.error("Phone number is empty or null");
    return;
  }
  const url = `tel:${phoneNumber}`;
  try {
    Linking.openURL(url);
    analytics.trackEvent(eventName, analyticsProps);
    if (callback && typeof callback === "function") {
      callback();
    }
  } catch (error) {
    console.log(error);
  }
};
export default handleCallButtonPress;
